@if (showView) {
  <mat-accordion>
    <mat-expansion-panel hideToggle="true" expanded="true">
      <div class='inner-panel'>
        <form action="" [formGroup]="tileFormGroup">
          @if (type === 'include' || type === 'exclude') {
            <div>
              <div class="two-column">
                <div class="column">
                  <div cbInput label="Name"
                    hideRequiredMarker="true"
                    [errorState]="tileFormGroup.controls.nameControl.invalid && tileFormGroup.controls.nameControl.touched"
                    [class.has-error]="tileFormGroup.controls.nameControl.invalid && tileFormGroup.controls.nameControl.touched">
                    <input [formControl]="tileFormGroup.controls.nameControl"
                      [ngClass]="{'fs-exclude': true}"
                      appAnalytics="focusout"
                      eventCategory="JobType" eventAction="USER_INPUT"
                      [eventLabel]="'Name :' + gaMask.gaNameMask(tileFormGroup.controls.nameControl.value)" />
                    </div>
                  </div>
                  <div class="column">
                    <div [cbSelectChoice]="titleSelect" label="Title" [hideRequiredMarker]="true" styleVariant="gray-fill">
                      <p-select #titleSelect
                        [formControl]="tileFormGroup.controls.jobTitleControl"
                        [options]="blockDetails.titleList"
                        optionLabel="wcOfficerTitleName"
                        optionValue="wcOfficerTitleCode"
                        placeholder="Select Title"
                        inputId="jobTitle"
                        appendTo="body"
                        (onChange)="getValue($event.value, 'Title')">
                      </p-select>
                    </div>
                  </div>
                  <div class="column_button">
                    @if (viewIndex !== 0) {
                      <button type="button" (click)="removeTile($event)" class="remove_btn"
                        appAnalytics="focusout"
                        eventCategory="JobType" eventAction="USER_INPUT"
                        [eventLabel]="type + 'Owners/Officers - Removed'">
                        <img class="remove_icon" src="/assets/img/job-type/icon-remove.svg">
                        Remove
                      </button>
                    }
                  </div>
                </div>
                <div class="two-column">
                  <div class="column">
                    @if (!entityDisabled) {
                      <div [cbSelectChoice]="entitySelect" label="Company structure" [hideRequiredMarker]="true" styleVariant="gray-fill">
                        <p-select #entitySelect
                          [formControl]="tileFormGroup.controls.entityTypeControl"
                          [options]="companyStructure"
                          optionLabel="wcEntityName"
                          optionValue="wcEntityCode"
                          placeholder="Select Company Structure"
                          inputId="entityType"
                          [disabled]="entityDisabled"
                          appendTo="body"
                          (onChange)="getValue($event.value, 'Company structure')">
                        </p-select>
                      </div>
                    }
                    @if (entityDisabled) {
                      <p class="labelDescription">Company Structure</p>
                      <p class="displayValue">{{companyStructure[0].wcEntityName}}</p>
                    }
                  </div>
                  <div class="column">
                    <p class="labelDescription">State</p>
                    <p class="displayValue">{{state}}</p>
                  </div>
                  <div class="column_button">
                    @if (viewIndex === (length - 1)) {
                      @if (ifAddLink(ccs.empLimits)) {
                        <button type="button" (click)="emitAddTile()" class="add_btn"
                          appAnalytics="focusout"
                          eventCategory="JobType" eventAction="USER_INPUT"
                          [eventLabel]="type + 'Owners/Officers - Added'">
                          <img class="add_icon" src="/assets/img/job-type/icon-add.svg">
                          Add more
                        </button>
                      }
                    }
                  </div>
                </div>
                <div class="two-column-mobile">
                  @if (viewIndex !== 0) {
                    <button type="button" (click)="removeTile($event)" class="remove_btn"
                      appAnalytics="focusout"
                      eventCategory="JobType" eventAction="USER_INPUT"
                      [eventLabel]="type + 'Owners/Officers - Removed'">
                      <img class="remove_icon" src="/assets/img/job-type/icon-remove.svg">
                      Remove
                    </button>
                  }
                  @if (viewIndex === (length - 1)) {
                    @if (ifAddLink(ccs.empLimits)) {
                      <button type="button" (click)="emitAddTile()" class="add_btn"
                        appAnalytics="focusout"
                        eventCategory="JobType" eventAction="USER_INPUT"
                        [eventLabel]="type + 'Owners/Officers - Added'">
                        <img class="add_icon" src="/assets/img/job-type/icon-add.svg">
                        Add more
                      </button>
                    }
                  }
                </div>
              </div>
            }
            @if (type === 'jobtype') {
              <div>
                <div class="jobtype-container">
                  <div class="column-75">
                    <div class="wrapper">
                      <div cbSearchInput label="Job type" colorTheme="default"
                        styleVariant="default" sizeVariant="bodyRegular" paddingVariant="default"
                        hideRequiredMarker="true">
                        <div class="cb-search-input__wrapper">
                          <p-autoComplete
                            [formControl]="tileFormGroup.controls.jobTypeControl"
                            [suggestions]="jobTypeSuggestions"
                            (completeMethod)="searchJobType($event)"
                            (onSelect)="getValue($event, 'Job type')"
                            (onBlur)="onJobTypeBlur()"
                            (onFocus)="onFocusShowAll()"
                            (onHide)="onJobTypeDropdownHide()"
                            placeholder="Search all job types by job description or class code"
                            [minLength]="0"
                            [completeOnFocus]="true"
                            [showClear]="false"
                            panelStyleClass="emp-tile-ac-panel"
                            [panelStyle]="{'max-width': '600px'}"
                            appendTo="body">
                            <ng-template pTemplate="item" let-item>{{ item.alteredDesc }}</ng-template>
                          </p-autoComplete>
                        </div>
                      </div>
                      <!-- <crux-dropdown #jobTypeSelectForIncluded placeholder="Job type" label=""
                      appearance="chubb" [formControl]="tileFormGroup.controls.jobTypeControl"
                      [items]="jobTypeArray" valueProp="classCode" displayProp="classCodeDescription"
                      ngDefaultControl [validationMsgs]="errorMessages.jobTypeErrors.employeeRequired"
                      required
                      (onValueChange)="getValue($event, 'Job type')">
                    </crux-dropdown> -->
                    @if (duplicateJobTypeError) {
                      <div class="error-text">This job type has already been
                      entered. Please choose another one.</div>
                    }
                    @if (jobTypeArray && jobTypeArray.length === 0) {
                      <div class="error-text">{{errorMessages.jobTypeErrors.employeeRequired.invalid}}</div>
                    }
                  </div>
                </div>
                <div class="column_button">
                  @if (viewIndex !== 0) {
                    <button type="button" (click)="removeTile($event)" class="remove_btn"
                      appAnalytics="focusout"
                      eventCategory="JobType" eventAction="USER_INPUT"
                      [eventLabel]="'Employee ' + type + '- Removed'">
                      <img class="remove_icon" src="/assets/img/job-type/icon-remove.svg">
                      Remove
                    </button>
                  }
                </div>
              </div>
              <div class="three-column">
                <div class="column">
                  @if (type !== 'jobtype') {
                    <img class="form-icons"
                      [ngClass]="tileFormGroup.controls.jobTypeControl.value ? 'employee' : 'employee-greyed'">
                  }
                  <div class="wrapper">
                    @if (type !== 'jobtype') {
                      <div [cbSelectChoice]="ftEmpSelect"
                        label="Full-time Employees" [hideRequiredMarker]="true" styleVariant="gray-fill">
                        <p-select #ftEmpSelect
                          [formControl]="tileFormGroup.controls.ftEmpControl"
                          [options]="officerDropdownValues"
                          optionLabel="text"
                          optionValue="value"
                          placeholder="Select..."
                          inputId="ftEmp"
                          [disabled]="!tileFormGroup.controls.jobTypeControl.value"
                          appendTo="body"
                          (onChange)="restOtherValue($event.value, 'pt')">
                        </p-select>
                      </div>
                    }
                    @if (type === 'jobtype') {
                      <div class="slider-wrapper">
                        <div class="employee-payroll">
                          <div class="wrapper">
                            <div cbInput label="Full-time employees"
                              hideRequiredMarker="true"
                              [errorState]="showEmpRequiredError && !ftEmpControl.value"
                              [class.has-error]="showEmpRequiredError && !ftEmpControl.value">
                              <input name="ftEmp" class="slider-value" type="text"
                                mask="separator"
                                (input)="setSlider('ftEmp', ccs.empLimits)"
                                [formControl]="ftEmpControl"
                                appAnalytics="focusout"
                                eventCategory="JobType" eventAction="USER_INPUT"
                                [eventLabel]="'Full time employees :' + ftEmpControl.value" />
                              </div>
                            </div>
                          </div>
                          @if (showEmpRequiredError &&
                            (
                            ( !ftEmpControl.value && !ptEmpControl.value ) ||
                            ( ftEmpControl.value == '0' && !ptEmpControl.value ) ||
                            ( !ftEmpControl.value && ptEmpControl.value == '0' ) ||
                            ( ftEmpControl.value == '0' && ptEmpControl.value == '0' )
                            )) {
                            <div class="error-text error-alignment"> Please enter the number of
                            employees.</div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                  <div class="column">
                    @if (type !== 'jobtype') {
                      <img class="form-icons"
                        [ngClass]="tileFormGroup.controls.jobTypeControl.value ? 'employee' : 'employee-greyed'">
                    }
                    <div class="wrapper">
                      @if (type !== 'jobtype') {
                        <div [cbSelectChoice]="ptEmpSelect"
                          label="Part-time Employees" [hideRequiredMarker]="true" styleVariant="gray-fill">
                          <p-select #ptEmpSelect
                            [formControl]="tileFormGroup.controls.ptEmpControl"
                            [options]="officerDropdownValues"
                            optionLabel="text"
                            optionValue="value"
                            placeholder="Select..."
                            inputId="ptEmp"
                            [disabled]="!tileFormGroup.controls.jobTypeControl.value"
                            appendTo="body"
                            (onChange)="restOtherValue($event.value, 'ft')">
                          </p-select>
                        </div>
                      }
                      @if (type === 'jobtype') {
                        <div class="slider-wrapper">
                          <div class="employee-payroll">
                            <div class="wrapper">
                              <div cbInput label="Part-time employees"
                                hideRequiredMarker="true"
                                [errorState]="showEmpRequiredError && !tileFormGroup.controls.ptEmpControl.value"
                                [class.has-error]="showEmpRequiredError && !tileFormGroup.controls.ptEmpControl.value">
                                <input mask="separator" name="ptEmp" class="slider-value"
                                  type="text" (input)="setSlider('ptEmp', ccs.empLimits)"
                                  [formControl]="tileFormGroup.controls.ptEmpControl"
                                  appAnalytics="focusout"
                                  eventCategory="JobType" eventAction="USER_INPUT"
                                  [eventLabel]="'Part time employees :' + tileFormGroup.controls.ptEmpControl.value" />
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                    <div class="column">
                      @if (type !== 'jobtype') {
                        <img class="form-icons"
                          [ngClass]="tileFormGroup.controls.jobTypeControl.value ? 'dollar' : 'dollar-greyed'">
                      }
                      <div class="slider-wrapper">
                        <div class="employee-payroll">
                          <div class="wrapper">
                            <div cbInput label="Employee payroll" prefix="$"
                              hideRequiredMarker="true"
                              [errorState]="payrollControl.invalid && payrollControl.touched"
                              [class.has-error]="payrollControl.invalid && payrollControl.touched">
                              <input required type="text" mask="separator.2" thousandSeparator=","
                                name="payroll" class="slider-value"
                                [formControl]="payrollControl"
                                (input)="setPayrollSlider(ccs.payrollLimits)"
                                appAnalytics="focusout"
                                eventCategory="JobType" eventAction="USER_INPUT"
                                [eventLabel]="'Employee Payroll :' + payrollControl.value" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="column_button">
                        @if (viewIndex === (length - 1)) {
                          @if (ifAddLink(ccs.empLimits)) {
                            <button type="button" (click)="emitAddTile()" class="add_btn"
                              appAnalytics="focusout"
                              eventCategory="JobType" eventAction="USER_INPUT"
                              [eventLabel]="'Employee ' + type + '- Added'">
                              <img class="add_icon" src="/assets/img/job-type/icon-add.svg">
                              Add more
                            </button>
                          }
                        }
                      </div>
                    </div>
                    <div class="two-column-mobile">
                      @if (viewIndex !== 0) {
                        <button type="button" (click)="removeTile($event)" class="remove_btn"
                          appAnalytics="focusout"
                          eventCategory="JobType" eventAction="USER_INPUT"
                          [eventLabel]="'Employee ' + type + '- Removed'">
                          <img class="remove_icon" src="/assets/img/job-type/icon-remove.svg">
                          Remove
                        </button>
                      }
                      @if (viewIndex === (length - 1)) {
                        @if (ifAddLink(ccs.empLimits)) {
                          <button type="button" (click)="emitAddTile()" class="add_btn"
                            appAnalytics="focusout"
                            eventCategory="JobType" eventAction="USER_INPUT"
                            [eventLabel]="'Employee ' + type + '- Added'">
                            <img class="add_icon" src="/assets/img/job-type/icon-add.svg">
                            Add more
                          </button>
                        }
                      }
                    </div>
                  </div>
                }
              </form>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      }